import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/trailerTransportOrder/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/trailerTransportOrder',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/trailerTransportOrder',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/trailerTransportOrder/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/trailerTransportOrder',
    method: 'get',
    params: {
      id
    }
  })
}

export function listOptions(params) {
  return request({
    url: '/api/trailerTransportOrder/listOptions',
    method: 'get',
    params
  })
}
